import { render, staticRenderFns } from "./SelfAssessment.vue?vue&type=template&id=25e2bf66&"
import script from "./SelfAssessment.vue?vue&type=script&lang=js&"
export * from "./SelfAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports